export default {
  name: 'ToggleButton',
  mixins: [],
  components: {},
  props: {
    background: {
      type: String,
      default: 'white'
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '13, 185, 194'
    },
    border: {
      type: Number,
      default: 4
    }
  },
  computed: {
    componentStyle () {
      return {
        '--background-spinner': this.background,
        '--size-spinner': `${this.size}px`,
        '--color-spinner': this.color,
        '--border-spinner': `${this.border}px`
      }
    }
  }
}
